(() => {
  // ✅ Mobile-only guard (desktop par kuch nahi karna)
  if (window.innerWidth >= 991) return;

  let initialized = false;

  function initAccordions() {
    const accordions = document.querySelectorAll(".footer-accordion");
    if (!accordions.length) return;

    accordions.forEach((accordion) => {
      const items = accordion.querySelectorAll(":scope > .accordion-item");

      // ✅ STEP 1: Saare reads pehle (forced reflow kam)
      const initialHeights = [];
      items.forEach((item) => {
        const header = item.querySelector(":scope > .accordion-header");
        initialHeights.push(header ? header.offsetHeight : 0);
      });

      // ✅ STEP 2: Saare writes baad mein
      items.forEach((item, index) => {
        if (item.dataset.init) return;
        item.dataset.init = "true";

        const header = item.querySelector(":scope > .accordion-header");
        const content = item.querySelector(":scope > .accordion-content");
        if (!header || !content) return;

        // ✅ Per-item rafId (global nahi — race condition fix)
        let rafId = null;

        // ✅ Cached heights
        let cachedHeaderHeight = initialHeights[index];
        let cachedContentHeight = content.scrollHeight;

        // ✅ Accessibility: initial state
        header.setAttribute("role", "button");
        header.setAttribute("tabindex", "0");
        header.setAttribute("aria-expanded", "false");

        // Unique content ID for aria-controls
        if (!content.id) {
          content.id = "accordion-content-" + Math.random().toString(36).slice(2, 9);
        }
        header.setAttribute("aria-controls", content.id);
        content.setAttribute("aria-hidden", "true");

        const setHeight = (el, height) => {
          el.style.height = height + "px";
        };

        const updateHeight = (el, force = false) => {
          if (!force && !el.classList.contains("open")) return;

          if (rafId) cancelAnimationFrame(rafId);
          rafId = requestAnimationFrame(() => {
            const head = el.querySelector(":scope > .accordion-header");
            const cont = el.querySelector(":scope > .accordion-content");
            if (!head || !cont) return;

            if (el.classList.contains("open")) {
              setHeight(el, cachedHeaderHeight + cachedContentHeight);
            } else {
              setHeight(el, head.offsetHeight);
            }

            // ✅ Parent (nested accordion) update
            const parentItem = el.parentElement && el.parentElement.closest(".accordion-item");
            if (parentItem && parentItem.classList.contains("open")) {
              const parentHead = parentItem.querySelector(":scope > .accordion-header");
              const parentCont = parentItem.querySelector(":scope > .accordion-content");
              if (parentHead && parentCont) {
                setHeight(parentItem, parentHead.offsetHeight + parentCont.scrollHeight);
              }
            }
          });
        };

        const toggleItem = () => {
          const isNowOpen = !item.classList.contains("open");

          // Close siblings (sirf open wale)
          const parentAccordion = item.parentElement;
          if (parentAccordion) {
            parentAccordion.querySelectorAll(":scope > .accordion-item.open").forEach((sib) => {
              if (sib === item) return;
              sib.classList.remove("open");
              const sibHeader = sib.querySelector(":scope > .accordion-header");
              const sibContent = sib.querySelector(":scope > .accordion-content");
              if (sibHeader) {
                setHeight(sib, sibHeader.offsetHeight);
                sibHeader.setAttribute("aria-expanded", "false");
              }
              if (sibContent) sibContent.setAttribute("aria-hidden", "true");
            });
          }

          // Toggle current
          item.classList.toggle("open", isNowOpen);
          header.setAttribute("aria-expanded", String(isNowOpen));
          content.setAttribute("aria-hidden", String(!isNowOpen));

          // Cache refresh jab open ho
          if (isNowOpen) {
            cachedHeaderHeight = header.offsetHeight;
            cachedContentHeight = content.scrollHeight;
          }

          updateHeight(item, true);
        };

        // ✅ Click handler
        header.addEventListener("click", (e) => {
          e.preventDefault();
          toggleItem();
        });

        // ✅ Keyboard accessibility (Enter / Space)
        header.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggleItem();
          }
        });

        // ✅ Initial closed height
        item.style.height = cachedHeaderHeight + "px";

        // ✅ Debounced ResizeObserver
        let resizeTimeout = null;
        const ro = new ResizeObserver(() => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            if (item.classList.contains("open")) {
              cachedHeaderHeight = header.offsetHeight;
              cachedContentHeight = content.scrollHeight;
              updateHeight(item, true);
            }
          }, 100);
        });
        ro.observe(header);
        ro.observe(content);

        // ✅ Cleanup (memory leak prevention)
        item._cleanup = () => {
          ro.disconnect();
          clearTimeout(resizeTimeout);
          if (rafId) cancelAnimationFrame(rafId);
        };
      });
    });
  }

  function triggerInit() {
    if (initialized) return;
    initialized = true;
    initAccordions();
  }

  // ✅ BEST: Sirf tab init jab footer viewport ke paas aaye
  const footerAccordion = document.querySelector(".footer-accordion");
  if (footerAccordion && "IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          if ("requestIdleCallback" in window) {
            requestIdleCallback(triggerInit, { timeout: 1000 });
          } else {
            triggerInit();
          }
        }
      },
      { rootMargin: "300px" } // 300px pehle hi init ho jaye
    );
    observer.observe(footerAccordion);
  } else {
    // ✅ Fallback (older browsers / element not found)
    if (document.readyState === "complete" || document.readyState === "interactive") {
      setTimeout(triggerInit, 0);
    } else {
      document.addEventListener("DOMContentLoaded", triggerInit, { once: true });
    }
  }
})();